import { UserRoleEnum } from '@/constants/enum'
import i18n from '@/services/i18n'
import Modal from '../Modal'

const open = (role?: UserRoleEnum) => {
  const descKey =
    role === UserRoleEnum.OWNER ? 'wallet.detail.notBackupDesc' : 'wallet.detail.notBackupDesc2'
  Modal.confirm({
    title: i18n.t('wallet.detail.notBackupLocalKey'),
    content: i18n.t(descKey),
    cancelButtonProps: { style: { display: 'none' } },
  })
}

export default {
  open,
}
